import React, { useEffect, useState } from "react";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import { notification } from "antd";
import "./invitationformcomponent.css";
import AddEditWorkforceFormComponent from "../../carecoordinator/workforce/AddEditWorkforceFormComponent";
import { strings } from "../../utils/strings";
import CustomModal from "../../../components/generic/custommodal/CustomModal";
import primary_logo from "../../landingpage/assets/pdvimages/logo.svg";
import { convertDateToEODTimestamp } from "../../../utils/dateutils";
import { useNavigate } from "react-router";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";

const InvitationFormComponent = ({
  workforce,
  setWorkforce,
  formSubmitCallback,
  customButtons,
  metadata,
  setMetadata,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const organizationIdentifier = useGetOrgIdentifier();
  const navigate = useNavigate()

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const validate = (values) => {
    const errors = {};
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
    const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;

    const requiredFields = [
      { field: "givenName", message: strings.FIRST_NAME_ERROR_MESSAGE },
      { field: "familyName", message: strings.LAST_NAME_ERROR_MESSAGE },
      { field: "completeAddress", message: strings.ADDRESS_ERROR_MESSAGE },
    ];

    requiredFields.forEach(({ field, message }) => {
      if (!values?.[field]) {
        errors[field] = message;
      }
    });

    if (values?.email && !emailRegex.test(values.email)) {
      errors.email = strings.VALID_EMAIL_ERROR_MESSAGE;
    }

    if (!passwordRegex.test(values?.password)) {
      errors.password = strings.PASSWORD_ERROR_MESSAGE;
    } else if (values.password !== values.confirmPassword) {
      errors.confirmPassword = strings.CONFIRM_PASSWORD_ERROR_MESSAGE;
    }

    return errors;
  };

  const handleFormSave = (e) => {
    e.preventDefault();
    setFormErrors(validate(workforce));
    setIsSubmit(true);
  };

  const saveVolunteerInfo = async () => {
    setIsLoading(true);
    const payload = {
      data: {
        userIdentifier: workforce?.userIdentifier,
        givenName: workforce?.givenName,
        familyName: workforce?.familyName,
        email: workforce?.email,
        telephone: workforce?.telephone,
        organizationIdentifier: organizationIdentifier,
        jobTitle: workforce?.jobTitle,
        gender: workforce?.gender,
        password: workforce?.password,
        birthDate:
          workforce?.birthDate &&
          convertDateToEODTimestamp(workforce?.birthDate),
        latitude: workforce?.latitude,
        longitude: workforce?.longitude,
        address: {
          streetAddress: workforce?.streetAddress,
          addressLocality: workforce?.addressLocality,
          addressRegion: workforce?.addressRegion,
          postalCode: workforce?.postalCode,
          completeAddress: workforce?.completeAddress,
          addressCountry: workforce?.addressCountry,
        },
        metadata: JSON.stringify(metadata),
        creatorIdentifier: workforce?.userIdentifier,
      },
    };
    try {
      const response = await executeIntent(
        IntentType.ACCEPT_INVITATION,
        payload,
      );
      if (response?.id) {
        formSubmitCallback();
      } else {
        notification.error({
          message: strings.COULD_NOT_SUBMIT,
          placement: "bottomRight",
        });
      }
    } catch (err) {
      notification.error({
        message: strings.COULD_NOT_SUBMIT,
        placement: "bottomRight",
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (workforce?.status === "Onboarded" || workforce?.status === "Revoked") {
      setOpenModal(true);
    }
  }, [workforce?.status]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      saveVolunteerInfo();
    }
  }, [formErrors, isSubmit]);

  return (
    <>
      {workforce?.status === "Onboarded" || workforce?.status === "Revoked" ? (
        <CustomModal
          isModalOpen={openModal}
          footer={workforce?.status === "Revoked" ? [<div className="button-section">
      <div>
        <PrimaryButton
          buttonText="Close"
          handleOnClick={() => navigate("/")}
          invitationForm={true}
        />
      </div>
    </div>] : [customButtons]}
          closeModal={setOpenModal}
          closable={false}
        >
          <div>
            <h5 className="font-weight-bold">{workforce?.status === "Onboarded" ? strings.REGISTERED : strings.REVOKED}</h5>
            <p>{workforce?.status === "Onboarded" ? strings.ACCOUNT_ALREADY_REGISTERED : strings.ACCOUNT_REVOKED}</p>
          </div>
        </CustomModal>
      ) : (
        <>
          <img className="invitation-logo" src={primary_logo} alt="logo" />
          <div className="invitation-form-container">
            <h2 className="lets-get-started">Let's get started</h2>
            <AddEditWorkforceFormComponent
              workforceData={workforce}
              setWorkforceData={setWorkforce}
              metadata={metadata}
              setMetadata={setMetadata}
              formErrors={formErrors}
              invitationFormProps={{
                handleFormSave: handleFormSave,
                buttonLoader: isLoading,
                invitationForm: true,
              }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default InvitationFormComponent;
